

































import Vue from "vue";
import Component from "vue-class-component";
import {Project, ProjectMetaData} from "../model/interface/project.interface";
import {ProjectService} from "../services/project.service";
import {MessageBus} from "../services/messageBus";
import {AlertType} from "../model/enum/alert.enum";
import ProjectCardComponent from "./project-card.vue";
import ProjectAddComponent from "./project-add.vue";
import {Client} from "../model/interface/client.interface";

@Component({
  components: {
    ProjectCardComponent,
    ProjectAddComponent
  }
})
export default class DashboardComponent extends Vue {
  private projects: ProjectMetaData[] = [];
  private loading: boolean = false;
  private showAddDialog: number = 0;

  async mounted() {
    this.loading = true;
    try {
      this.projects = await ProjectService.getAllProjects();
      this.projects.sort((a: ProjectMetaData, b: ProjectMetaData) => {
        if (a.id < b.id) {
          return -1;
        }
        if (a.id > b.id) {
          return 1;
        }
        return 0;
      });
    } catch (e) {
      MessageBus.$emit(AlertType[AlertType.error], e);
      console.error(e);
    } finally {
      this.loading = false;
    }
  }

  private showAddDialogAction() {
    this.showAddDialog++;
  }
}

